import { enableProdMode } from "@angular/core";
import { environment } from "environments/environment";

import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { mainConfig } from "./app/app.config";

if (environment.production) {
  window.console.log = () => {};
  enableProdMode();
}

bootstrapApplication(AppComponent, mainConfig).catch((err) =>
  console.error(err)
);
